import {
  ScopedSocialSharingData,
  ShareDropdown,
  toCopyLink,
  toSharable,
} from 'components/Dropdown/Dropdown';
import { DropdownAnchor } from 'components/Dropdown/DropdownAnchor';
import { ShareDropdownButton } from 'components/Sharing/ShareDropdownButton';
import { getGribbles } from 'contexts/EggContext';
import { queryKeys } from 'contexts/QueryClient';
import { useUser } from 'hooks/useUser';
import React from 'react';
import { useQuery } from 'react-query';
import { gtag } from 'utils/analytics';
import { GRIBBLE_CONTRACT_ADDRESS } from 'utils/contract';
import { getUserGribbles } from 'utils/PointsAPI';
import { nftMarketplaceUrl, OpenSeaItem, SocialMediaType } from 'utils/socials';
import styles from './GribbleCollection.module.scss';

const GribbleCollection = () => {
  const { account, moralis } = useUser();
  const ethAddress = moralis?.user?.attributes?.authData?.moralisEth?.id;
  const userId = account.dusktech?.userId;

  const gribbles = useQuery(
    queryKeys.gribbles(ethAddress),
    async () => {
      if (!userId) {
        throw Error('No userId');
      }
      const result = await getGribbles(ethAddress);
      const ownedGribbles = result.map(({ tokenId }) => parseInt(tokenId, 10));
      return getUserGribbles(userId, ownedGribbles);
    },
    {
      enabled: moralis.isAuthenticated && userId !== undefined,
    },
  );

  return (
    <div className={styles.gribbleCollection}>
      <h3>You own {gribbles.data?.length || 0} gribble(s)</h3>
      <div className={styles.gribbleList}>
        {gribbles.data &&
          gribbles.data.length > 0 &&
          gribbles.data.map(({ tokenId, imageUrl }) => (
            <div className={styles.gribble} key={tokenId}>
              <img src={imageUrl.toString()} alt="gribble" />
              <div className={styles.gribbleDetails}>
                <p>Gribble #{tokenId}</p>
                <DropdownAnchor>
                  <GribbleSharing
                    gribble={{ contract: GRIBBLE_CONTRACT_ADDRESS, nftId: Number(tokenId) }}
                  />
                </DropdownAnchor>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

type GribbleSharingProps = {
  gribble: OpenSeaItem;
};

export const GribbleSharing = ({ gribble }: GribbleSharingProps) => {
  const gribbleLink = nftMarketplaceUrl.openSea(gribble);
  const supportedShareTargets: SocialMediaType[] = ['twitter', 'telegram', 'reddit', 'facebook'];

  const fallback = {
    text: `Check out my #DuskBreakers Gribble on OpenSea: ${gribbleLink.toString()}`,
    link: gribbleLink,
  };

  const data: ScopedSocialSharingData = {
    twitter: {
      text: `Check out my #DuskBreakers Gribble on OpenSea by @duskbreakers: ${gribbleLink.toString()}`,
      link: gribbleLink,
    },
    fallback,
  };
  return (
    <ShareDropdownButton data={fallback}>
      <ShareDropdown
        invert
        name="Share"
        sections={[[toCopyLink(gribbleLink.toString())], toSharable(supportedShareTargets, data)]}
        onClick={() => gtag('event', 'gribble share')}
      />
    </ShareDropdownButton>
  );
};

export default GribbleCollection;
